import { highlightReportEvidence, RESPONSE_INK, REFERENCE_INK } from './reportEmphasis';
import { highlightReportKeywords, REPORT_KEYWORDS } from './reportKeywords';
export const reportEmphasisRuns = (text, responses = []) => {
  const doc = document.implementation.createHTMLDocument('');
  doc.body.textContent = text;
  highlightReportEvidence(doc.body, 'code,pre', responses);
  highlightReportKeywords(doc.body, 'code,pre');
  const runs = [], walker = doc.createTreeWalker(doc.body, 4);
  while (walker.nextNode()) {
    const node = walker.currentNode, parent = node.parentElement, keyword = parent.closest('.report-keyword');
    const colour = keyword ? REPORT_KEYWORDS[keyword.dataset.reportKeyword]?.ink : parent.closest('.report-reference') ? REFERENCE_INK : parent.closest('.report-user-response') ? RESPONSE_INK : null;
    runs.push({ text: node.nodeValue, colour, bold: !!colour });
  }
  return runs;
};
// Style measured words without changing the existing body text or margins.
export const drawReportEmphasis = (pdf, text, { responses, font, size, x, y, width, pageHeight, margin, lineHeight }) => {
  const tokens = []; let token = [];
  reportEmphasisRuns(text, responses).forEach(run => Array.from(run.text).forEach(char => {
    const c = { char, colour: run.colour, bold: run.bold };
    if (/\s/.test(char)) { if (token.length) tokens.push(token); tokens.push([c]); token = []; } else token.push(c);
  }));
  if (token.length) tokens.push(token);
  const style = c => { pdf.setFont(font, c.bold ? 'bold' : 'normal'); pdf.setFontSize(size); pdf.setTextColor(c.colour || '#141414'); };
  const groups = chars => {
    const result = [];
    chars.forEach(c => { const last = result[result.length - 1]; if (last && last.colour === c.colour) last.text += c.char; else result.push({ ...c, text: c.char }); });
    return result;
  };
  const measure = chars => groups(chars).reduce((total, g) => { style(g); return total + pdf.getTextWidth(g.text); }, 0);
  let line = [], used = 0;
  const flush = () => {
    if (y > pageHeight - margin) { pdf.addPage(); y = margin; }
    let left = x;
    groups(line).forEach(g => { style(g); pdf.text(g.text, left, y); left += pdf.getTextWidth(g.text); });
    y += lineHeight; line = []; used = 0;
  };
  tokens.forEach(t => {
    if (t[0].char === '\n') { flush(); return; }
    const w = measure(t);
    if (used + w > width && line.length) flush();
    if (!line.length && /^\s$/.test(t[0].char)) return;
    line.push(...t); used += w;
  });
  if (line.length) flush();
  pdf.setTextColor(20, 20, 20);
  return y;
};
